import type { ComponentProps, Ref } from 'react';
import type { CSSProperties, HTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export type PillClusterProps = ComponentProps<'div'>;

export function PillCluster({ className, ...props }: PillClusterProps) {
  return <div className={cx('pill-cluster', className)} {...props} />;
}

export interface ClusterItemProps extends HTMLAttributes<HTMLSpanElement> {
  phase: 'enter' | 'exit';
  index?: number;
}

export function ClusterItem(
  { ref, phase, index, className, children, ...rest }: ClusterItemProps & { ref?: Ref<HTMLSpanElement> },
) {
  const stagger = phase === 'enter' && index !== undefined ? ({ '--i': index } as CSSProperties) : undefined;
  return (
    <span
      ref={ref}
      className={cx(phase === 'enter' ? 'cluster-enter' : 'cluster-exit', className)}
      style={stagger}
      {...rest}
    >
      {children}
    </span>
  );
}
